import { IdentityProviderModel, Metadata } from '../../hickory-api';
import { IDENTITY_PROVIDERS_AUTHZ_DOMAIN, AuthZAccessControl } from '../../shared/authentication/access-control';
import { AuthService } from '../../shared/authentication/auth.service';


export class SelectedIdentityProviderContext {

  public readonly availableActions?: string[];
  public readonly isReadonly?: boolean;
  public readonly canEdit?: boolean;
  public readonly authzDomain = IDENTITY_PROVIDERS_AUTHZ_DOMAIN;

  constructor(
    authService: AuthService,
    public readonly tenantId?: number,
    public readonly provider?: IdentityProviderModel
  ) {
    this.tenantId = tenantId;
    this.provider = provider;
    this.availableActions = AuthZAccessControl.getActionsFromEntity(authService, this.authzDomain, provider);
    this.isReadonly = AuthZAccessControl.isReadonlyOrEmpty(this.availableActions);
    this.canEdit = this.availableActions.includes('update');
  }

  updateMetadata(metadata: Metadata): this {
    this.provider.metadata = {
      ...this.provider.metadata,
      ...metadata
    };
    return this;
  }

  validForUpdate(): boolean {
    return !!this.provider?.id && !!this.tenantId && !this.isReadonly && this.canEdit;
  }
}
